import { BASE_URL, GATEWAY_BASE_URL, DOLPHIN_BASE_URL } from '@/settings'
import axios from 'axios'
import store from '../store'
import server from '../server'
import { createToastNotification } from './toast'

export const PandaService = axios.create({
  baseURL: BASE_URL,
  timeout: 0
})

PandaService.interceptors.request.use(
  (config) => {
    if (server.token) {
      config.headers['Authorization'] = 'Bearer ' + server.token
    }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

PandaService.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, async function (error) {
  if (error.response && error.response.status === 401) {
    store.dispatch('redirectToAuthentication')
  } else {
    let message = ''
    if (error.response && error.response.data.message) {
      message = error.response.data.message
    } else if (error.response && error.response.statusText) {
      message = error.response.statusText
    } else if (error.response && error.response.status) {
      message = error.response.status
    } else {
      message = error || ''
    }

    createToastNotification(message, { type: 'error', position: 'bottom' })
  }
  return ''
})

export const GatewayService = axios.create({
  baseURL: GATEWAY_BASE_URL,
  timeout: 0
})

GatewayService.interceptors.request.use(
  (config) => {
    if (server.token) {
      config.headers['Authorization'] = 'Bearer ' + server.token
    }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

GatewayService.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, async function (error) {
  if (error.response && error.response.status === 401) {
    store.dispatch('redirectToAuthentication')
  } else {
    let message = ''
    if (error.response && error.response.data.message) {
      message = error.response.data.message
    } else if (error.response && error.response.statusText) {
      message = error.response.statusText
    } else if (error.response && error.response.status) {
      message = error.response.status
    } else {
      message = error || ''
    }

    createToastNotification(message, { type: 'error', position: 'bottom' })
  }
  return ''
})

export const DolphinService = axios.create({
  baseURL: DOLPHIN_BASE_URL,
  timeout: 0
})

DolphinService.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

DolphinService.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, async function (error) {
  if (error.response && error.response.status === 401) {
    store.dispatch('redirectToAuthentication')
  } else {
    let message = ''
    if (error.response && error.response.data.message) {
      message = error.response.data.message
    } else if (error.response && error.response.statusText) {
      message = error.response.statusText
    } else if (error.response && error.response.status) {
      message = error.response.status
    } else {
      message = error || ''
    }

    createToastNotification(message, { type: 'error', position: 'bottom' })
  }
  return ''
})
